export enum AuthRoutes {
  LOGIN = "login",
}
